export default "__VITE_ASSET__CQtzooDC__"